<template>
  <div data-testid="reg-form">
    <div
      v-if="step != maxStepsCount"
      class="demo__flex demo__margin-bottom--24"
      v-bind:class="{
        'demo__flex-middle': !isMobile,
        'demo__flex-column': isMobile,
      }"
    >
      <div
        class="demo__font--20 demo__weight--600 demo__color--black demo__margin-right--16"
      >
        {{ $t("Reg for users " + displayStep) }}
      </div>
      <div
        class="demo__font--11 demo__weight--500 demo__color--textPrimaryGray"
        v-if="step !== maxStepsCount"
        v-bind:class="{
          'demo__margin-top--8': isMobile,
        }"
      >
        {{ $t("Step") }} {{ displayStep }} {{ $t("from") }}
        {{ maxStepsCount - 1 }}
      </div>
    </div>
    <component :is="'Step' + step" :form="form" :reg-result="regResult" />
  </div>
</template>

<script>
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";
import { mapGetters } from "vuex";

export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      regResult: undefined,
      step: 1,
      maxStepsCount: 3,
      form: {
        first_name: undefined,
        last_name: undefined,
        email: undefined,
        username: undefined,
        company: undefined,
        // position_in_the_company: undefined,
        phone: " ",
        password: undefined,
        professional_status: undefined,
        specialties: undefined,
        university: undefined,
        marketing_consent: false,
      },
    };
  },
  computed: {
    ...mapGetters(["api", "isMobile"]),
    displayStep() {
      return this.step < 2 ? this.step : 2;
    },
  },
  beforeDestroy() {
    this.$root.$off("changeRegStep", this.changeRegStep);
    this.$root.$off("regFinish", this.register);
  },
  created() {
    this.$accessModule("reg", this);
    this.$root.$on("changeRegStep", this.changeRegStep);
    this.$root.$on("regFinish", this.register);
  },
  methods: {
    changeRegStep(step) {
      this.regResult = undefined;
      if (step >= 1 && step <= this.maxStepsCount) {
        this.step = step;
      }
    },
    register() {
      this.form.username = this.form.email;
      this.form.phone = this.form.phone.replaceAll(" ", "");

      const additionalData =
        process.env.VUE_APP_VERIFY !== "on"
          ? {
              professional_status: 1,
              specialties: [1],
              university: 1017,
            }
          : {};

      this.api
        .register({
          data: {
            ...this.form,
            ...additionalData,
            redirect_url: `${window.location.pathname.slice(
              1
            )}#login-after-register`,
          },
        })
        .then((response) => {
          this.$debug("Успешная регистрация", "success", response.data);
          this.$root.$emit("changeRegStep", 3);
        })
        .catch((error) => {
          const error_message = error.message;

          let text;

          switch (error_message) {
            case "Network Error":
              text = this.$t("Auth error network");
              break;

            default:
              text = this.$t("Reg error");
              break;
          }

          this.$debug("Ошибка регистрации " + text, "error", error_message);

          //TODO обсудить список ошибок
          this.regResult = text;
          // this.$root.$emit("changeRegStep", 1);
        });
    },
  },
};
</script>
